/* ELUXION Theme JS */
document.addEventListener('DOMContentLoaded', function() {

  // ── Mobile menu ──────────────────────────────────────────
  const burger = document.getElementById('elx-burger');
  const mobileMenu = document.getElementById('elx-mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      burger.classList.toggle('open');
    });
  }

  // ── Cart drawer ──────────────────────────────────────────
  const cartTriggers = document.querySelectorAll('[data-open-cart]');
  const cartDrawer = document.getElementById('elx-cart-drawer');
  const cartOverlay = document.getElementById('elx-cart-overlay');
  const cartClose = document.getElementById('elx-cart-close');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }
  cartTriggers.forEach(t => t.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // ── Cart refresh (dynamic) ───────────────────────────────
  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      // Update badge
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      const itemsEl = document.getElementById('elx-cart-items');
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = `
          <div style="text-align:center;padding:40px 0;color:var(--gris-medio)">
            <div style="font-size:2rem;margin-bottom:12px">🛒</div>
            <p style="font-size:.9rem;">Tu carrito está vacío</p>
          </div>`;
        const footer = document.querySelector('.elx-cart-footer');
        if (footer) footer.style.display = 'none';
      } else {
        let html = '';
        cart.items.forEach(item => {
          const price = (item.final_line_price / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
          const img = item.image ? item.image.replace(/(\.\w+(\?.*)?$)/, '_144x144$1') : '';
          html += `<div class="elx-cart-item">
            ${img ? `<img class="elx-cart-item-img" src="${img}" alt="${item.title}">` : ''}
            <div class="elx-cart-item-info">
              <div class="elx-cart-item-name">${item.title}</div>
              <div class="elx-cart-item-price">${price}</div>
              <div style="font-size:.78rem;color:var(--gris-medio);margin-top:4px">Cantidad: ${item.quantity}</div>
            </div>
          </div>`;
        });
        itemsEl.innerHTML = html;

        const totalPrice = (cart.total_price / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
        let footer = document.querySelector('.elx-cart-footer');
        if (!footer) {
          footer = document.createElement('div');
          footer.className = 'elx-cart-footer';
          document.getElementById('elx-cart-drawer')?.appendChild(footer);
        }
        footer.style.display = '';
        footer.innerHTML = `
          <div class="elx-cart-total">
            <span style="font-size:.9rem;font-weight:400;">Total</span>
            <span>${totalPrice}</span>
          </div>
          <a href="/checkout" class="elx-btn elx-btn-primary" style="width:100%;justify-content:center;">Finalizar compra →</a>
          <a href="/cart" style="display:block;text-align:center;margin-top:12px;font-size:.8rem;color:var(--gris-medio);">Ver carrito completo</a>`;
      }
    } catch(e) {}
  }

  // Load on page start
  refreshCartDrawer();

  // ── FAQ accordion ────────────────────────────────────────
  document.querySelectorAll('.elx-faq-question').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.closest('.elx-faq-item');
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.elx-faq-item').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  // ── Before/After slider ──────────────────────────────────
  document.querySelectorAll('.elx-ba-interactive').forEach(container => {
    let dragging = false;
    const beforeImg = container.querySelector('.elx-ba-before-img');
    const divider = container.querySelector('.elx-ba-divider');
    function setPosition(x) {
      const rect = container.getBoundingClientRect();
      let pct = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
      if (beforeImg) beforeImg.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      if (divider) divider.style.left = pct + '%';
    }
    container.addEventListener('mousedown', e => { dragging = true; setPosition(e.clientX); });
    container.addEventListener('touchstart', e => { dragging = true; setPosition(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('mousemove', e => { if (dragging) setPosition(e.clientX); });
    document.addEventListener('touchmove', e => { if (dragging) setPosition(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('mouseup', () => dragging = false);
    document.addEventListener('touchend', () => dragging = false);
  });

  // ── Tabs (productos) ─────────────────────────────────────
  document.querySelectorAll('[data-tab-trigger]').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('[data-tab-group]');
      const target = btn.dataset.tabTrigger;
      if (!group) return;
      group.querySelectorAll('[data-tab-trigger]').forEach(b => b.classList.remove('active'));
      group.querySelectorAll('[data-tab-content]').forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      group.querySelector(`[data-tab-content="${target}"]`)?.classList.add('active');
    });
  });

  // ── Collection filter (productos page) ───────────────────
  const categoryFilter = document.getElementById('elx-category-filter');
  if (categoryFilter) {
    categoryFilter.addEventListener('change', function() {
      const val = this.value;
      document.querySelectorAll('[data-product-tag]').forEach(card => {
        if (!val || card.dataset.productTag.includes(val)) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  }

  // ── Scroll reveal ────────────────────────────────────────
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.elx-reveal').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity .6s ease, transform .6s ease';
    observer.observe(el);
  });

  // ── Header scroll effect ─────────────────────────────────
  const header = document.getElementById('elx-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 50 ? '0 4px 30px rgba(0,0,0,.3)' : 'none';
    });
  }

  // ── Add to cart (Shopify AJAX) ───────────────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      const qty = parseInt(this.dataset.qty || '1');
      if (!variantId) return;
      this.disabled = true;
      this.textContent = 'Añadiendo...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        if (res.ok) {
          this.textContent = '✓ Añadido';
          await refreshCartDrawer();
          setTimeout(() => openCart(), 300);
        }
      } catch(err) { console.error(err); }
      setTimeout(() => { this.disabled = false; this.textContent = this.dataset.originalText || 'Añadir al carrito'; }, 2000);
    });
  });

  // ── Product quantity controls ────────────────────────────
  document.querySelectorAll('[data-qty-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[type=number]');
      if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[type=number]');
      if (input) input.value = parseInt(input.value) + 1;
    });
  });
});
